module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/react-facebook/~/core-js/library/modules/_add-to-unscopables.js
// module id = 948
// module chunks = 0